import HARDCODE from '../../business-const/HardCode/HardCode'



const parentescoList = (listaCompleta) => {
   
   const parentescoListAux = []

   if (listaCompleta) {

      parentescoListAux.push(
         {
            id: 1, // HARDCODE.idParentescoCliente // HARDCODEBACKEND.idParentescoCliente
            descricao: 'Cliente',
            gerarEducacao: 'N',
            geracao: HARDCODE.geracao1,
            ordem: 1,
         },
         {
            id: 2, // HARDCODE.idParentescoConjuge // HARDCODEBACKEND.idParentescoConjuge
            descricao: 'Cônjuge',
            gerarEducacao: 'N',
            geracao: HARDCODE.geracao1,
            ordem: 2,
         },
      )
   }
   
   parentescoListAux.push(
      {
         id: 10, // HARDCODE.idParentescoFilhao // HARDCODEBACKEND.idParentescoFilhao
         descricao: 'Filha(o)',
         gerarEducacao: 'S',
         geracao: HARDCODE.geracao2,
         ordem: 10,
      },
      {
         id: 15, // HARDCODE.idParentescoEnteadao // HARDCODEBACKEND.idParentescoEnteadao
         descricao: 'Enteada(o)',
         gerarEducacao: 'S',
         geracao: null,
         ordem: 15,
      },
      {
         id: 20,
         descricao: 'Pai',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 20,
      },
      {
         id: 30,
         descricao: 'Mãe',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 30,
      },
      {
         id: 40,
         descricao: 'Irmã(o)',
         gerarEducacao: 'S',
         geracao: null,
         ordem: 40,
      },
      {
         id: 50,
         descricao: 'Avó(ô)',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 50,
      },
      {
         id: 60,
         descricao: 'Neta(o)',
         gerarEducacao: 'S',
         geracao: HARDCODE.geracao3,
         ordem: 60,
      },
      {
         id: 70,
         descricao: 'Tia(o)',
         gerarEducacao: 'S',
         geracao: null,
         ordem: 70,
      },
      {
         id: 80,
         descricao: 'Sobrinha(o)',
         gerarEducacao: 'S',
         geracao: null,
         ordem: 80,
      },
      {
         id: 90,
         descricao: 'Madrinha',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 90,
      },
      {
         id: 100,
         descricao: 'Padrinho',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 100,
      },
      {
         id: 110,
         descricao: 'Sogra(o)',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 110,
      },
      {
         id: 120,
         descricao: 'Ex-cônjuge',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 120,
      },
      {
         id: 810,
         descricao: 'Pet',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 810,
      },
      {
         id: 820,
         descricao: 'Sócio',
         gerarEducacao: 'N',
         geracao: null,
         ordem: 820,
      },
      {
         id: 900,
         descricao: 'Outros',
         gerarEducacao: 'S',
         geracao: null,
         ordem: 900,
      },
   )

   if (listaCompleta) {

      parentescoListAux.push(
         {
            id: 999, // HARDCODEBACKEND.idParentescoNaoInformado
            descricao: 'Não Informado',
            gerarEducacao: 'N',
            ordem: 999,
         },
      )
   }

   return parentescoListAux
}

export default parentescoList